angular.module 'zc.masterApi', [
]




// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/index.coffee